import ko from 'knockout';
import Backbone from 'backbone';
import ViewModel from '@bingads-webui-campaign-legacy/advanced-settings/viewmodel/ad-rotation';
import template from '@bingads-webui-campaign-legacy/advanced-settings/template/ad-rotation.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize(AdRotation = 'OptimizeForClicks', disableRotationOptions) {
    this.viewModel = new ViewModel(AdRotation, disableRotationOptions);
  }

  render() {
    this.$el.html(template({i18n}));
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  getValues() {
    return this.viewModel.toObject();
  }

  validate() {
    return this.viewModel.validate();
  }
}
